function Newsletter() {
    return (
        <section className="py-5">
            <div className="container">
                <div className="row justify-content-center text-center mb-4 mb-md-5">
                    <div className="col-xl-9 col-xxl-8">
                        <span className="text-muted">Read More</span>
                        <h2 className="display-5 fw-bold">Semiconductor Industry News</h2>
                        <p className="lead">
                            Stay updated with the latest developments in the global semiconductor industry.
                        </p>
                    </div>
                </div>
                
                <div className="row g-0 align-items-center">
                    <div className="col-md-6">
                        <img
                            alt="CHIPS Act Impact"
                            className="img-fluid"
                            src="https://example.com/chips-act.jpg"
                        />
                    </div>
                    <div className="col-md-6">
                        <div className="p-md-3 p-xl-5 mt-4 mt-md-0">
                            <a className="text-primary fw-semibold text-decoration-none" href="https://www.timesunion.com/opinion/article/editorial-chips-not-fall-20208401.php">
                                United States
                            </a>
                            <h2 className="fw-semibold my-1">CHIPS Act Under Scrutiny</h2>
                            <div className="text-muted">March 10, 2025</div>
                            <p className="my-4">
                                The CHIPS and Science Act has allocated $33 billion in subsidies, spurring $450 billion in private investments. However, political debates cast uncertainty on future funding.
                            </p>
                            <a className="btn btn-primary" href="https://www.timesunion.com/opinion/article/editorial-chips-not-fall-20208401.php">
                                Read more
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row g-0 align-items-center">
                    <div className="col-md-6 order-2 order-md-1">
                        <div className="p-md-3 p-xl-5 mt-4 mt-md-0">
                            <a className="text-primary fw-semibold text-decoration-none" href="https://www.thetimes.co.uk/article/uk-needs-tax-incentives-to-develop-semiconductor-industry-rmfdhmfht">
                                United Kingdom
                            </a>
                            <h2 className="fw-semibold my-1">Calls for Tax Incentives</h2>
                            <div className="text-muted">March 10, 2025</div>
                            <p className="my-4">
                                UK semiconductor leaders push for tax incentives and reduced electricity costs to attract investments. Pragmatic Semiconductor's facility is expected to boost local chip production.
                            </p>
                            <a className="btn btn-primary" href="https://www.thetimes.co.uk/article/uk-needs-tax-incentives-to-develop-semiconductor-industry-rmfdhmfht">
                                Read more
                            </a>
                        </div>
                    </div>
                    <div className="col-md-6 order-1 order-md-2">
                        <img
                            alt="UK Semiconductor Industry"
                            className="img-fluid"
                            src="https://example.com/uk-semiconductor.jpg"
                        />
                    </div>
                </div>

                <div className="row g-0 align-items-center">
                    <div className="col-md-6">
                        <img
                            alt="China EV Chips"
                            className="img-fluid"
                            src="https://example.com/china-ev-chips.jpg"
                        />
                    </div>
                    <div className="col-md-6">
                        <div className="p-md-3 p-xl-5 mt-4 mt-md-0">
                            <a className="text-primary fw-semibold text-decoration-none" href="https://www.wsj.com/tech/beijing-pushes-to-use-china-made-chips-in-its-evs-d89212de">
                                China
                            </a>
                            <h2 className="fw-semibold my-1">China Pushes for Local EV Chips</h2>
                            <div className="text-muted">March 10, 2025</div>
                            <p className="my-4">
                                China is accelerating efforts to integrate domestically produced semiconductor chips into electric vehicles, aiming for greater self-sufficiency in the global chip market.
                            </p>
                            <a className="btn btn-primary" href="https://www.wsj.com/tech/beijing-pushes-to-use-china-made-chips-in-its-evs-d89212de">
                                Read more
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Newsletter;
